import React from 'react';
import PropTypes from 'prop-types';
import '@fiverr/globals';

const SellerDeliveryTime = ({ deliveryTime }) => (
    <p className="seller-delivery-time">
        <span>Average Delivery:</span> {deliveryTime} {i18n.t('general.day')}{deliveryTime !== 1 && 's'}
    </p>
);

SellerDeliveryTime.propTypes = {
    deliveryTime: PropTypes.number
};

export default SellerDeliveryTime;



// WEBPACK FOOTER //
// ./src/shared/seller_delivery_time/index.js